module.exports = __webpack_public_path__ + "img/logoShow.c88df758.jpg";